(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputFileMultiple', cpInputFileMultiple);

    cpInputFileMultiple.$inject = [];

    function cpInputFileMultiple() {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            templateUrl: 'app/caffeprint/directives/input-file-multiple/input-file-multiple.html',
            scope: {
                title: '@',
                object: '=',
                prop: '@',
                isDisabled: '=?',
                onChange: '&?',

                labelClass: '@?',
                containerClass: '@',
                fullWidth: '@'
            },
            link: function(scope, element, attrs, controller) {
                scope.inputChange = inputChange;
                scope.reset = reset;

                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;
                scope.isWithLabel = isWithLabel;

                function inputChange(elem) {
                    scope.$apply(function() {
                        scope.object[scope.prop] = [];
                        angular.forEach(elem.files, function(item) {
                            scope.object[scope.prop].push(item);
                        });
                    });

                    if (scope.onChange) {
                        scope.onChange();
                    }
                }

                function reset() {
                    scope.object[scope.prop] = [];
                }

                function isWithLabel() {
                    return scope.fullWidth === undefined ? true : scope.withLabel;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
